<template>
    <div class="scope-arrangement-setting container">
        <div class="box-shadow-small border-radius" style="padding-bottom: 40px;">
            <div class="">
                <div style="padding-top: 30px;">
                    <thumbnail :text="baseInfo.name" :gender="baseInfo.gender=== 1 ? 'man': 'woman'" :font-size="16"
                               :width="110"></thumbnail>
                    <el-row class="mt-10 text-center" :gutter="10">
                        <el-col :span="8">应聘职位：{{ baseInfo.positionName }}</el-col>
                        <el-col :span="8">应聘部门：{{ baseInfo.deptNames }}</el-col>
                        <el-col :span="8">手机号：{{ baseInfo.phone }}</el-col>
                    </el-row>
                </div>
            </div>
            <template v-if="baseInfo.paperName">
                <div class="mt-25">
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-transition">
                        <table class="el-table__body" style="width: 100%;">
                            <tr class="el-table__row">
                                <td class="is-center" width="240">
                                    <div class="cell">考试标题</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">{{ baseInfo.examName || '-'}}</div>
                                </td>
                            </tr>
                            <tr class="el-table__row">
                                <td class="is-center">
                                    <div class="cell">考试须知</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">{{ baseInfo.examRules || '-' }}</div>
                                </td>
                            </tr>
                            <tr class="el-table__row">
                                <td class="is-center">
                                    <div class="cell">选择笔试题</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">
                                        <p v-for="(item, index) in baseInfo.paperList" :key="index">{{ item.name }}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr class="el-table__row">
                                <td class="is-center">
                                    <div class="cell">考试日期</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">
                                        <p v-for="(item, index) in baseInfo.examTimes" :key="index">
                                            {{ item.startTime }} - {{ item.endTime }}</p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="mt-25">
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-transition">
                        <table class="el-table__body" style="width: 100%;">
                            <tr class="el-table__row">
                                <td class="is-center" width="120">
                                    <div class="cell">系统评分总分</div>
                                </td>
                                <td class="is-center" width="180" colspan="2">
                                    <div class="cell">{{ baseInfo.privateScoreTotal || '-'}}</div>
                                </td>
                                <td class="is-center" width="120">
                                    <div class="cell">答卷</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">{{ baseInfo.paperName || '-'}}</div>
                                </td>
                                <td class="is-center" width="150">
                                    <div class="cell">答卷时间段</div>
                                </td>
                                <td class="is-center" width="250">
                                    <div class="cell">{{ baseInfo.startTime }} -  {{ (baseInfo.endTime || '').substring(11)}}</div>
                                </td>
                            </tr>
                            <tr class="el-table__row">
                                <td class="is-center" style="background: #eee;">
                                    <div class="cell">评估人</div>
                                </td>
                                <td class="is-center" style="background: #eee;">
                                    <div class="cell">系统评分</div>
                                </td>
                                <td class="is-center" style="background: #eee;">
                                    <div class="cell">面试官评分</div>
                                </td>
                                <td class="is-center" style="background: #eee;">
                                    <div class="cell">状态</div>
                                </td>
                                <td class="is-center" style="background: #eee;" colspan="3">
                                    <div class="cell">备注</div>
                                </td>
                            </tr>
                            <tr class="el-table__row" v-for="(item, index) in baseInfo.markExamList" :key="index">
                                <td class="is-center">
                                    <div class="cell">{{ item.markName || '-'}}</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">{{item.privateScore || '-'}}</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">{{item.score || '-'}}</div>
                                </td>
                                <td class="is-center">
                                    <div class="cell">{{item.result}}</div>
                                </td>
                                <td class="is-center" colspan="3">
                                    <div class="cell">{{ item.remark }}</div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </template>
            <empty-tip v-else></empty-tip>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Thumbnail from 'components/thumbnail'
    import EmptyTip from 'views/common/empty'

    export default {
        components: {
            Thumbnail,
            EmptyTip
        },
        data () {
            return {
                urls: {
                    fetch: '/arrangeExam/getExamInfo.api'
                },
                baseInfo: {},  // 基本信息
                baseData: {}  // item's data
            }
        },
        computed: {
            id () {
                return this.$route.params.id
            }
        },
        methods: {
            async fetchData () {
                let res1 = await this.$axios.get(this.urls.fetch, {params: {resumePositionId: this.id}})
                let res2 = await this.$axios.post('/resumePosition/interviewArrange/getListWithOutEva.api', {resumePositionId: this.id})

                this.baseInfo = Object.assign({}, res1.result.exam, {
                    positionName: res2.result.position.name,
                    deptNames: res2.result.position.deptNames,
                    gender: res2.result.resume.gender
                })
            },
            sendEmail (data, type) {
                let ids = []
                let users = {}
                data.forEach(item => {
                    ids.push(item.id)
                    let masterIds = item.masterInterviewer.split(','),
                        masterNames = item.masterInterviewerNames.split('，'),
                        interviewIds = item.interviewer.split(','),
                        interviewNames = item.interviewerNames.split('，')
                    item.interviewerUsers = []
                    if (item.masterInterviewer !== '') {
                        masterIds.forEach((mid, mindex) => {
                            users[mid] = masterNames[mindex]
                            item.interviewerUsers.push({
                                id: mid,
                                name: masterNames[mindex]
                            })
                        })
                    }
                    if (item.interviewer !== '') {
                        interviewIds.forEach((iid, iindex) => {
                            users[iid] = interviewNames[iindex]
                            item.interviewerUsers.push({
                                id: iid,
                                name: interviewNames[iindex]
                            })
                        })
                    }
                })
                this.$refs.sendEmail.show({
                    ids: this.baseData.id,
                    interviewIds: ids.join(','),
                    selecteds: data,
                    resumePositionList: [this.result],
                    phase: 2,
                    userAttributes: type
                })
            }
        },
        created () {
            this.fetchData()
        }
    }
</script>

<style type="text/css" lang="scss">
    @import "~style/app/arrangement.scss";
</style>



// WEBPACK FOOTER //
// writtenPersonDetail.vue?3e545a03